import { TimekeeperService } from "services/TimekeeperService";
const tk = new TimekeeperService();
const gettingExceptionRule = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setRows: React.Dispatch<React.SetStateAction<any[]>>
) => {
    setLoading(true);
    tk.exception_rules.getExceptionRules()
        .then((response) => {
            const rows = response.map((exception) => (
                {
                    id: exception.exception_rule_id,
                    name: exception.name,
                    no_planning: exception.not_planning,
                    long_interval: exception.long_interval,
                    shortened_shift: exception.shortened_shift,
                    punch_in: [exception.in_punch_very_early, exception.in_punch_early, exception.in_punch_late],
                    punch_out: [exception.out_punch_early, exception.out_punch_late, exception.out_punch_very_late],
                    description: exception.description,
                    in_paycode_id: exception.in_paycode_id,
                    out_paycode_id: exception.out_paycode_id,
                    in_paycode: exception.in_paycode,
                    out_paycode: exception.out_paycode
                }
            ))

            setRows(rows);
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
}

const createExceptionRule = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, body: any) => {
    setLoading(true);
    return await tk.exception_rules.createExceptionRule(body);
}

const getPaycodesDurationType = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, type: "paycode" | "paycode_combination" | "overtime" | "paycode_distribution" | "exception_rule" | "bonus_rule" | "credit_holiday_rule" | "standard" | "domino" | "duration") => {
    setLoading(true);
    return await tk.paycodes.getPaycodes(type);
}

const deleteExceptionRule = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, selectedRow: number) => {
    setLoading(true);
    return await tk.exception_rules.deleteExceptionRule(selectedRow)
}

const editExceptionRule = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, selectedRow: number, data: any) => {
    setLoading(true);
    const body = {
        name: data.name,
        not_planning: data.not_planning,
        long_interval: data.long_interval,
        shortened_shift: String(data.shortened_shift),
        in_punch_very_early: String(data.in_punch_very_early),
        in_punch_early: String(data.in_punch_early),
        in_punch_late: String(data.in_punch_late),
        out_punch_early: String(data.out_punch_early),
        out_punch_late: String(data.out_punch_late),
        out_punch_very_late: String(data.out_punch_very_late),
        in_paycode_id: data.in_paycode_id,
        out_paycode_id: data.out_paycode_id,
        description: data.description,
        enable: true
    }
    return await tk.exception_rules.updateExceptionRule(selectedRow, body);
}

export {
    gettingExceptionRule,
    createExceptionRule,
    getPaycodesDurationType,
    deleteExceptionRule,
    editExceptionRule
}